import type {
  SyntheticRunDetail,
  SyntheticJobStatus,
} from '../../services/syntheticJob.interface.js';

export interface UseSyntheticJobResult {
  /** Latest job snapshot from the server, or null until the first response. */
  job: SyntheticRunDetail | null;
  /** True until the very first response (success or failure) lands. */
  isLoading: boolean;
  /** Non-null when the most recent fetch failed. */
  error: string | null;
  /**
   * True when the job has reached a terminal status. Polling stops at this
   * point — callers can use this to drive transitions (e.g. show preview,
   * surface failure UI).
   */
  isTerminal: boolean;
}

/**
 * Lifecycle states the API reports. Re-exported for callers that don't want
 * to import from the service layer directly.
 */
export type { SyntheticJobStatus };

export const TERMINAL_STATUSES: ReadonlySet<SyntheticJobStatus> = new Set([
  'completed',
  'failed',
]);
